import AdFooterBaseComponent from "./footer.vue"
import AdHeaderBaseComponent from "./header.vue"
import AdNavsBaseComponent from "./navs.vue"
import AdFloatDownloadBaseComponent from "./floatDownload.vue"

const components = [
    AdFooterBaseComponent,
    AdHeaderBaseComponent,
    AdNavsBaseComponent,
    AdFloatDownloadBaseComponent
]

export default {
    install(Vue) {
        components.map(component => {
            Vue.component(component.name.replace("BaseComponent", ""), component)
        })
    }
}
